module.exports = __webpack_public_path__ + "static/media/Watertower_2.44de9070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower/Watertower_2.png
// module id = 1274
// module chunks = 3